import Typed from "react-typed";

import Avatar from "../Avatar/Avatar";
import styles from "./HomeContentLeft.module.scss";

import SocialMediaBadge from "../SocialMediaBadge/SocialMediaBadge";

function HomeContentLeft() {
  return (
    <>
      <div className={styles.personal}>
        <Avatar />
        <h3>Hi, im Ivan Mitrofanov.</h3>
      </div>
      <div className={styles.intro}>
        <h1 className={styles.headline}>
          <Typed
            strings={["Frontend developer.", "Fullstack developer."]}
            typeSpeed={60}
            backDelay={2000}
            backSpeed={60}
          />
        </h1>

        <p className={styles.description}>
          Since 2021, I have been creating digital applications for myself and
          my friends. I am currently working with React.js, Node.js, TypeScript
          and everything related to interfaces.
        </p>

        <p className={styles.description}>
          In my free time, I am a musician and a student of PSUTI =D.
        </p>
      </div>
      <div className={styles.socialMedia}>
        <SocialMediaBadge type="github" />
        <SocialMediaBadge type="telegram" />
        <SocialMediaBadge type="vk" />
        <SocialMediaBadge type="discord" />
      </div>
    </>
  );
}

export default HomeContentLeft;
